<div class="main-container">
  <div>
    <span id="ti-title" class="modal-title-info" ngClass.xs="m-0" ngClass="m-3">
      {{ 'ORDER-LIST-DETAILS.TS-TITLE-TRANSP-INFO' | translate }}
    </span>
    <button
      mat-raised-button
      color="primary"
      appDisableControl
      [disableControl]="saveTransportInfoInProgress"
      type="button"
      class="close mt-0"
      ngClass="mt-0"
      ngClass.xs="mt-3"
      id="edit-transport-information-button"
      aria-label="Edit transport information"
      [disabled]="
        !this.template ||
        cannotSaveCompartments ||
        this.order.isReadOnly ||
        isImpersonated
      "
      [title]="
        !this.template
          ? MissingTemplateInfoLabel
          : transportInformationDisabled
          ? EditTransportInfoLabel
          : SaveTransportInfoLabel
      "
      [ngClass]="transportInformationCollapsed ? 'hide-element' : ''"
      (click)="
        transportInformationDisabled
          ? this.toggleTransportInformation()
          : submitTransportInformation(transportInfoForm)
      "
    >
      {{
        transportInformationDisabled
          ? ('SHARED.EDIT' | translate)
          : ('SHARED.SAVE' | translate)
      }}
    </button>
  </div>

  <div
    *ngIf="this.order"
    [ngbCollapse]="timeslotCollapsed"
    id="collapseTransportInformation"
  >
    <div class="primary card card-body my-5">
      <div
        id="error-message-transport-information"
        class="error-message"
        *ngIf="
          submitted &&
          !transportInformationDisabled &&
          transportInfoForm &&
          !transportInfoForm.valid
        "
      >
        {{ 'SHARED.ERROR-GLOBAL-FIELDS' | translate }}
      </div>
      <div>
        <div
          class="d-flex flex-row basis-100 gap-48 xs-flex-column sm-flex-column xs-gap-48 md-gap-32 sm-gap-32"
        >
          <div class="d-flex flex-row basis-50 flex-1">
            <div
              class="hide-mobile d-flex flex-column basis-25 lg-basis-35 md-basis-40 sm-basis-35"
            >
              <div
                class="actuals-title d-flex flex-column gap-16 xs-gap-0"
                [formGroup]="transportInfoForm"
              >
                <div
                  *ngIf="this.transportInfoForm.get('DriverName')"
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-1"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-DN' | translate }}
                  </h3>
                </div>

                <div
                  *ngIf="
                    this.transportInfoForm.get('PrefixNumber') &&
                    this.transportInfoForm.get('MobileNumber')
                  "
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-1"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-DMN' | translate }}
                  </h3>
                </div>
                <div
                  *ngIf="this.transportInfoForm.get('HaulierName')"
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-1"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-CN' | translate }}
                  </h3>
                </div>
                <div
                  *ngIf="this.transportInfoForm.get('SealsNeededAfterLoading')"
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-1"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-NS' | translate }}
                  </h3>
                </div>

                <div
                  *ngIf="this.transportInfoForm.get('EquipmentClass')"
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-1"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-EC' | translate }}
                  </h3>
                </div>

                <div
                  *ngIf="this.transportInfoForm.get('CleaningStatus')"
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-1"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-CS' | translate }}
                  </h3>
                </div>
                <div
                  *ngIf="this.transportInfoForm.get('PreviousProductType')"
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-1"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-PPT' | translate }}
                  </h3>
                </div>
              </div>
            </div>

            <div
              class="d-flex flex-column basis-75 lg-basis-65 md-basis-60 xs-basis-100 sm-basis-65"
            >
              <div class="d-flex flex-row">
                <form
                  #transportInfoId
                  [formGroup]="transportInfoForm"
                  class="d-flex flex-row basis-100"
                >
                  <div
                    class="d-flex flex-column basis-100 gap-16 xs-gap-0"
                  >
                    <div
                      class="hide-tablet-portrait hide-desktop hide-tablet-landscape"
                      *ngIf="this.transportInfoForm.get('DriverName')"
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-DN' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="this.transportInfoForm.get('DriverName')"
                    >
                      <input
                        [attr.disabled]="formDisabled"
                        formControlName="DriverName"
                        pattern="[a-zA-Z0-9 ]*"
                        id="driver-name"
                        class="input-text form-actuals-height"
                        [(ngModel)]="transportInformation.driverName"
                        name="driverNameInput"
                      />
                    </div>
                    <div
                      class="hide-tablet-portrait hide-desktop hide-tablet-landscape d-flex flex-column"
                      style="padding-left: 0px"
                      *ngIf="
                        this.transportInfoForm.get('PrefixNumber') &&
                        this.transportInfoForm.get('MobileNumber')
                      "
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-DMN' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      *ngIf="
                        this.transportInfoForm.get('PrefixNumber') &&
                        this.transportInfoForm.get('MobileNumber')
                      "
                      class="field-mob form-actuals-height d-flex flex-row"
                    >
                      <div
                        class="d-flex flex-column basis-20 xs-basis-35 sm-basis-30 md-basis-44 lg-basis-35"
                        *ngIf="
                          this.transportInfoForm.get('PrefixNumber') &&
                          this.transportInfoForm.get('MobileNumber')
                        "
                      >
                        <select
                          [attr.disabled]="formDisabled"
                          id="driver-mobile-prefix"
                          formControlName="PrefixNumber"
                          class="input-text select form-actuals-height"
                          [class.preview-mode]="formDisabled"
                          [(ngModel)]="driverMobileNumberPrefix"
                          name="drivePrefixNumberInput"
                        >
                          <option value=""></option>
                          <option
                            *ngFor="let option of prefixes"
                            value="{{ option.prefix }}"
                          >
                            {{ this.formPrefix(option.prefix, option.code) }}
                          </option>
                        </select>
                      </div>
                      <div
                        class="d-flex flex-column basis-80 xs-basis-65 sm-basis-70 md-basis-56 lg-basis-65"
                        *ngIf="
                          this.transportInfoForm.get('PrefixNumber') &&
                          this.transportInfoForm.get('MobileNumber')
                        "
                      >
                        <input
                          [attr.disabled]="formDisabled"
                          id="driver-mobile"
                          formControlName="MobileNumber"
                          class="input-text form-actuals-height"
                          [(ngModel)]="driverMobileNumber"
                          name="driveMobileNumberInput"
                          [appFormatDirective]="'^[0-9]*$'"
                        />
                      </div>
                    </div>
                    <div
                      class="hide-tablet-portrait hide-desktop hide-tablet-landscape"
                      *ngIf="this.transportInfoForm.get('HaulierName')"
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-CN' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="this.transportInfoForm.get('HaulierName')"
                    >
                      <input
                        pattern="[a-zA-Z0-9 ]*"
                        [attr.disabled]="formDisabled"
                        formControlName="HaulierName"
                        id="company-name"
                        class="input-text form-actuals-height"
                        [(ngModel)]="transportInformation.companyName"
                        name="companyNameInput"
                      />
                    </div>
                    <div
                      class="hide-tablet-portrait hide-desktop hide-tablet-landscape"
                      *ngIf="
                        this.transportInfoForm.get('SealsNeededAfterLoading')
                      "
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-NS' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="
                        this.transportInfoForm.get('SealsNeededAfterLoading')
                      "
                    >
                      <input
                        [attr.disabled]="formDisabled"
                        formControlName="SealsNeededAfterLoading"
                        appWeightValidation
                        [maxWeight]="99"
                        id="number-of-seals"
                        class="input-text form-actuals-height"
                        [(ngModel)]="transportInformation.numberOfSeals"
                        [appFormatDirective]="'^[0-9]{1,2}$'"
                        name="numberOfSealsInput"
                      />
                    </div>
                    <div
                      class="hide-tablet-portrait hide-desktop hide-tablet-landscape"
                      *ngIf="this.transportInfoForm.get('EquipmentClass')"
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-EC' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="this.transportInfoForm.get('EquipmentClass')"
                    >
                      <select
                        formControlName="EquipmentClass"
                        [(ngModel)]="transportInformation.equipmentClass"
                        [attr.disabled]="formDisabled"
                        name="equipmentClassInput"
                        [class.preview-mode]="formDisabled"
                        id="equipment-class-input"
                        class="input-text select form-actuals-height"
                      >
                        <option [value]="this.equipmentClass.Food">Food</option>
                        <option [value]="this.equipmentClass.Feed">Feed</option>
                        <option [value]="this.equipmentClass.Technical">
                          Technical
                        </option>
                      </select>
                    </div>
                    <div
                      class="hide-tablet-portrait hide-desktop hide-tablet-landscape"
                      *ngIf="this.transportInfoForm.get('CleaningStatus')"
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-CS' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="this.transportInfoForm.get('CleaningStatus')"
                    >
                      <select
                        formControlName="CleaningStatus"
                        [(ngModel)]="transportInformation.cleaningStatus"
                        [attr.disabled]="formDisabled"
                        name="cleaningStatusInput"
                        [class.preview-mode]="formDisabled"
                        id="cleaning-status-input"
                        class="input-text select form-actuals-height"
                      >
                        <option
                          [value]="this.cleaningStatus.LoadWithoutCleaning"
                        >
                          Load without cleaning
                        </option>
                        <option
                          [value]="this.cleaningStatus.CleanAtLoadLocation"
                        >
                          Clean at load location
                        </option>
                        <option [value]="this.cleaningStatus.CleanedOnArrival">
                          Cleaned on arrival
                        </option>
                        <option
                          [value]="
                            this.cleaningStatus.CleanedAtApprovedEFTCOStation
                          "
                        >
                          Cleaned at approved EFTCO station
                        </option>
                        <option
                          [value]="
                            this.cleaningStatus.CleanedAtNonApprovedEFTCStation
                          "
                        >
                          Cleaned at non approved EFTCO station
                        </option>
                      </select>
                    </div>
                    <div
                      class="hide-tablet-portrait hide-desktop hide-tablet-landscape"
                      *ngIf="this.transportInfoForm.get('PreviousProductType')"
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-PPT' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="this.transportInfoForm.get('PreviousProductType')"
                    >
                      <select
                        formControlName="PreviousProductType"
                        [(ngModel)]="transportInformation.previousProductType"
                        [attr.disabled]="true"
                        [class.preview-mode]="formDisabled"
                        name="previousProductInput"
                        id="previous-product-input"
                        class="input-text select previous-product-type form-actuals-height"
                      >
                        <option [value]="this.previousProductType.Halal">
                          Halal
                        </option>
                        <option [value]="this.previousProductType.Kosher">
                          Kosher
                        </option>
                        <option [value]="this.previousProductType.GMP">
                          GMP+
                        </option>
                      </select>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row basis-50">
            <div
              class="d-flex flex-column basis-25 lg-basis-35 md-basis-40 sm-basis-35"
              class="hide-mobile"
            >
              <div
                class="actuals-title d-flex flex-column gap-16 xs-gap-0"
                [formGroup]="transportInfoForm"
              >
                <div
                  *ngIf="this.transportInfoForm.get('TruckType')"
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-2"
                  >
                    Truck type
                  </h3>
                </div>
                <div
                  *ngIf="this.transportInfoForm.get(CONTROL_NAME_TRUCK_LICENSE)"
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-2"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-LP' | translate }}
                  </h3>
                </div>
                <div
                  *ngIf="
                    this.transportInfoForm.get(CONTROL_NAME_SEMITRAILER_LICENSE)
                  "
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-2"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-SLP' | translate }}
                  </h3>
                </div>
                <div
                  *ngIf="
                    this.transportInfoForm.get(CONTROL_NAME_CONTAINER_NUMBER) &&
                    this.transportInformation.truckType ==
                      this.truckType.IsoContainer
                  "
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-2"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-IN' | translate }}
                  </h3>
                </div>

                <div
                  *ngIf="
                    this.transportInfoForm.get(CONTROL_NAME_SCOPA) &&
                    this.transportInformation.truckType ==
                      this.truckType.Trailer
                  "
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-2"
                  >
                    Scopa ID
                  </h3>
                </div>
                <div
                  *ngIf="this.transportInfoForm.get('TaraWeight')"
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-2"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-TW' | translate }}
                  </h3>
                </div>
                <div
                  *ngIf="this.transportInfoForm.get('MaxWeight')"
                  class="d-flex flex-column"
                >
                  <h3
                    class="mobile-font-size-details-on-blue centered-title-mob transport-label-col-2"
                  >
                    {{ 'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-MGW' | translate }}
                  </h3>
                </div>
              </div>
            </div>

            <div
              class="d-flex flex-column basis-75 lg-basis-65 xs-basis-100 md-basis-60 sm-basis-65"
            >
              <div class="d-flex flex-column mr-0">
                <form
                  [formGroup]="transportInfoForm"
                  class="d-flex flex-column basis-100"
                >
                  <div
                    class="d-flex flex-column basis-100 gap-16 xs-gap-0"
                  >
                    <div
                      class="hide-desktop hide-tablet-portrait hide-tablet-landscape"
                      *ngIf="this.transportInfoForm.get('TruckType')"
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        Truck type
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="this.transportInfoForm.get('TruckType')"
                    >
                      <select
                        [attr.disabled]="formDisabled"
                        formControlName="TruckType"
                        [class.preview-mode]="formDisabled"
                        [(ngModel)]="transportInformation.truckType"
                        name="truckTypeInput"
                        id="truck-type-input"
                        class="input-text select form-actuals-height"
                      >
                        <option [value]="this.truckType.Trailer">
                          Trailer
                        </option>
                        <option [value]="this.truckType.IsoContainer">
                          Tank container
                        </option>
                      </select>
                    </div>
                    <div
                      class="hide-desktop hide-tablet-portrait hide-tablet-landscape"
                      *ngIf="
                        this.transportInfoForm.get(CONTROL_NAME_TRUCK_LICENSE)
                      "
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-LP' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="
                        this.transportInfoForm.get(CONTROL_NAME_TRUCK_LICENSE)
                      "
                    >
                      <input
                        [attr.disabled]="formDisabled"
                        formControlName="{{ CONTROL_NAME_TRUCK_LICENSE }}"
                        appAlphaNumericDirective
                        appToUpperCase
                        id="truck-license-plate"
                        class="input-text form-actuals-height"
                        [(ngModel)]="transportInformation.truckLicensePlate"
                        name="truckLicensePlateInput"
                        (paste)="onPaste($event, CONTROL_NAME_TRUCK_LICENSE)"
                        (change)="onChange(CONTROL_NAME_TRUCK_LICENSE)"
                      />
                    </div>
                    <div
                      class="hide-desktop hide-tablet-portrait hide-tablet-landscape d-flex flex-column"
                      *ngIf="
                        this.transportInfoForm.get(
                          CONTROL_NAME_SEMITRAILER_LICENSE
                        )
                      "
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-SLP' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="
                        this.transportInfoForm.get(
                          CONTROL_NAME_SEMITRAILER_LICENSE
                        )
                      "
                    >
                      <input
                        [attr.disabled]="formDisabled"
                        formControlName="{{ CONTROL_NAME_SEMITRAILER_LICENSE }}"
                        appAlphaNumericDirective
                        appToUpperCase
                        id="semitrailer-license-plate"
                        class="input-text form-actuals-height"
                        [(ngModel)]="
                          transportInformation.semitrailerLicensePlate
                        "
                        (focusout)="this.uploadCompartments($event)"
                        name="semiTrailerLicensePlateInput"
                        (paste)="
                          onPaste($event, CONTROL_NAME_SEMITRAILER_LICENSE)
                        "
                        (change)="onChange(CONTROL_NAME_SEMITRAILER_LICENSE)"
                      />
                    </div>

                    <div
                      class="hide-desktop hide-tablet-portrait hide-tablet-landscape d-flex flex-column"
                      *ngIf="isIsoContainer"
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-IN' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="isIsoContainer"
                    >
                      <input
                        [attr.disabled]="formDisabled"
                        formControlName="{{ CONTROL_NAME_CONTAINER_NUMBER }}"
                        appAlphaNumericDirective
                        appToUpperCase
                        id="tc-unit-number"
                        class="input-text form-actuals-height"
                        pattern="[A-Z]{4}\d{7}"
                        [(ngModel)]="
                          transportInformation.tankContainerLicensePlate
                        "
                        appTankContainerNrDirective
                        (focusout)="this.uploadCompartments($event)"
                        name="tcUnitNumberInput"
                        (paste)="onPaste($event, CONTROL_NAME_CONTAINER_NUMBER)"
                        (change)="onChange(CONTROL_NAME_CONTAINER_NUMBER)"
                      />
                    </div>
                    <div
                      class="hide-desktop hide-tablet-portrait hide-tablet-landscape d-flex flex-column"
                      *ngIf="
                        this.transportInfoForm.get(CONTROL_NAME_SCOPA) &&
                        this.transportInformation.truckType ==
                          this.truckType.Trailer
                      "
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        Scopa ID
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="
                        this.transportInfoForm.get(CONTROL_NAME_SCOPA) &&
                        this.transportInformation.truckType ==
                          this.truckType.Trailer
                      "
                    >
                      <input
                        [attr.disabled]="formDisabled"
                        formControlName="{{ CONTROL_NAME_SCOPA }}"
                        appAlphaNumericDirective
                        appToUpperCase
                        id="scopa-id"
                        class="input-text form-actuals-height"
                        pattern="\d{10}"
                        [(ngModel)]="transportInformation.scopaId"
                        name="scopaIdInput"
                        (paste)="onPaste($event, CONTROL_NAME_SCOPA)"
                        (change)="onChange(CONTROL_NAME_SCOPA)"
                      />
                    </div>
                    <div
                      class="hide-desktop hide-tablet-portrait hide-tablet-landscape d-flex flex-column"
                      *ngIf="this.transportInfoForm.get('TaraWeight')"
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-TW' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="this.transportInfoForm.get('TaraWeight')"
                    >
                      <input
                        *ngIf="!formDisabled"
                        formControlName="TaraWeight"
                        appWeightValidation
                        [maxWeight]="99999"
                        id="tare-weight"
                        class="input-text form-actuals-height"
                        [appFormatDirective]="'^[1-9][0-9]{0,4}$'"
                        [(ngModel)]="transportInformation.tareWeight"
                        name="tareWeightInput"
                      />

                      <input
                        *ngIf="formDisabled"
                        formControlName="TaraWeight"
                        [attr.disabled]="true"
                        id="tare-weight"
                        class="input-text form-actuals-height"
                        value="{{ transportInformation.tareWeight | number }}"
                        name="tareWeightInput"
                      />
                    </div>
                    <div
                      class="hide-desktop hide-tablet-portrait hide-tablet-landscape d-flex flex-column"
                      *ngIf="this.transportInfoForm.get('MaxWeight')"
                    >
                      <h3
                        class="mobile-font-size-details-on-blue centered-title-mob"
                      >
                        {{
                          'ORDER-LIST-DETAILS.TS-TRANSP-TITLE-MGW' | translate
                        }}
                      </h3>
                    </div>
                    <div
                      class="field-mob form-actuals-height d-flex flex-column"
                      *ngIf="this.transportInfoForm.get('MaxWeight')"
                    >
                      <input
                        *ngIf="!formDisabled"
                        formControlName="MaxWeight"
                        appWeightValidation
                        [maxWeight]="99999"
                        id="max-gross-weight"
                        [appFormatDirective]="'^[1-9][0-9]{0,4}$'"
                        class="input-text form-actuals-height"
                        [(ngModel)]="transportInformation.maximumGrossWeight"
                        name="maxGrossWeightInput"
                      />
                      <input
                        *ngIf="formDisabled"
                        [attr.disabled]="true"
                        formControlName="MaxWeight"
                        id="max-gross-weight"
                        class="input-text form-actuals-height"
                        value="{{
                          transportInformation.maximumGrossWeight | number
                        }}"
                        name="maxGrossWeightInput"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="add-compartment">
        <button
          mat-raised-button
          color="primary"
          [disabled]="
            maxNumberOfCompartmentsReached ||
            formDisabled ||
            this.order.isReadOnly
          "
          type="button"
          class="close px-2"
          title="Add new compartment"
          id="add-transport-button"
          (click)="addNewCompartment()"
        >
          {{ 'SHARED.ADD-BUTTON' | translate }}
        </button>
      </div>

      <div class="card">
        <div
          id="error-message-product-registration"
          class="error-message"
          *ngIf="
            submitted &&
            !transportInformationDisabled &&
            productInformationDataSource?.data.length == 0 &&
            this.requireCompartments
          "
        >
          {{ 'ORDER-LIST-DETAILS.NO-PRODUCTS-REGISTERED' | translate }}
        </div>
        <div
          id="error-message-incomplete-compartment-info"
          class="error-message"
          *ngIf="
            submitted &&
            !transportInformationDisabled &&
            this.invalidCompartmentInfo
          "
        >
          {{ 'ORDER-LIST-DETAILS.INCOMPLETE-COMPARTMENT-INFO' | translate }}
        </div>
        <div *ngIf="productInformationDataSource">
          <div class="container-row-grey">
            <mat-table
              id="product-registration"
              class="table table-striped carrier-overview-table mat-table-modal-multi table-blue-container compartments-dynamic-scroll"
              [dataSource]="productInformationDataSource"
              matSort
              *ngIf="
                !this.showCompartmentsAsCards();
                else collapsibleCompartments
              "
            >
              <mat-header-row
                *matHeaderRowDef="productInformationColumns"
                class="compartment-header"
              ></mat-header-row>
              <mat-row *matRowDef="let row; columns: productInformationColumns">
              </mat-row>

              <ng-container matColumnDef="compartment">
                <mat-header-cell
                  *matHeaderCellDef
                  mat-header-cell
                  mat-sort-header
                  class="mat-table-header"
                  >{{
                    'ORDER-LIST-DETAILS.TS-PROD-TABLE-TITLE-COMP' | translate
                  }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span>{{ element.compartmentNumber }}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="capacity">
                <mat-header-cell
                  *matHeaderCellDef
                  mat-header-cell
                  class="mat-table-header"
                  >{{
                    'ORDER-LIST-DETAILS.TS-PROD-TABLE-TITLE-CAPACITY'
                      | translate
                  }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span>{{ element.compartmentCapacity }}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="previousProduct1">
                <mat-header-cell
                  *matHeaderCellDef
                  mat-header-cell
                  class="mat-table-header"
                >
                  {{
                    'ORDER-LIST-DETAILS.TS-PROD-TABLE-TITLE-PROD-1' | translate
                  }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span>{{ element.previousProduct1 }} </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="IDTF1">
                <mat-header-cell
                  *matHeaderCellDef
                  mat-header-cell
                  class="mat-table-header"
                >
                  IDTF1
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span>{{ element.idtF1 }} </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="previousProduct2">
                <mat-header-cell
                  *matHeaderCellDef
                  mat-header-cell
                  class="mat-table-header"
                >
                  {{
                    'ORDER-LIST-DETAILS.TS-PROD-TABLE-TITLE-PROD-2' | translate
                  }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span>{{ element.previousProduct2 }} </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="IDTF2">
                <mat-header-cell
                  *matHeaderCellDef
                  mat-header-cell
                  class="mat-table-header"
                >
                  IDTF2
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span>{{ element.idtF2 }} </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="previousProduct3">
                <mat-header-cell
                  mat-header-cell
                  *matHeaderCellDef
                  class="mat-table-header"
                >
                  {{
                    'ORDER-LIST-DETAILS.TS-PROD-TABLE-TITLE-PROD-3' | translate
                  }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span>{{ element.previousProduct3 }} </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="IDTF3">
                <mat-header-cell
                  *matHeaderCellDef
                  mat-header-cell
                  class="mat-table-header"
                >
                  IDTF3
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span>{{ element.idtF3 }} </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>

                <mat-cell *matCellDef="let element">
                  <button
                    *ngIf="!transportInformationDisabled"
                    type="button"
                    class="close"
                    title="Edit compartment"
                    (click)="editCompartment(element)"
                    style="margin-right: 2rem"
                  >
                    <em
                      class="title-action-btn fa fa-pencil-alt"
                      aria-hidden="true"
                    ></em>
                  </button>
                  <button
                    *ngIf="!transportInformationDisabled"
                    type="button"
                    class="close"
                    title="Delete compartment"
                    (click)="deleteCompartment(element)"
                  >
                    <em
                      class="title-action-btn fa fa-trash"
                      aria-hidden="true"
                    ></em>
                  </button>
                </mat-cell>
              </ng-container>
            </mat-table>

            <div
              *ngIf="productInformationDataSource.data?.length == 0"
              class="no-results"
            >
              {{ 'ORDER-LIST-DETAILS.NO-COMPARTMENTS-TEXT' | translate }}
            </div>
          </div>
          <ng-template #collapsibleCompartments>
            <mat-accordion multi>
              <mat-expansion-panel
                #compartmentExpansionPanel
                class="compartment-card-text-color"
                *ngFor="let element of productInformationDataSource.data"
                (opened)="openCompartmentPanel(compartmentExpansionPanel)"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <b>{{ element.compartmentNumber }}</b>
                    &nbsp;
                    <span class="compartment-card-text-color">
                      {{ element.compartmentCapacity }} ltr</span
                    >
                  </mat-panel-title>
                  <mat-panel-description>
                    <button
                      *ngIf="!transportInformationDisabled"
                      type="button"
                      class="close"
                      title="Delete compartment"
                      (click)="deleteCompartment(element)"
                      (click)="$event.stopPropagation()"
                    >
                      <em
                        class="title-action-btn fa fa-trash"
                        aria-hidden="true"
                      ></em>
                    </button>
                    <button
                      *ngIf="!transportInformationDisabled"
                      type="button"
                      class="close"
                      title="Edit compartment"
                      (click)="editCompartment(element)"
                      (click)="$event.stopPropagation()"
                      style="margin-right: 2em"
                    >
                      <em
                        class="title-action-btn fa fa-pencil-alt"
                        aria-hidden="true"
                      ></em>
                    </button>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="row wrapper-expansion-text">
                  <div class="compartment-card-text">
                    <b>{{ element.previousProduct1 }}</b>
                  </div>
                  <div class="compartment-card-text">
                    {{ element.idtF1 }}
                  </div>
                </div>
                <div class="row wrapper-expansion-text">
                  <div class="compartment-card-text">
                    <b>{{ element.previousProduct2 }}</b>
                  </div>
                  <div class="compartment-card-text">
                    {{ element.idtF2 }}
                  </div>
                </div>
                <div class="row wrapper-expansion-text">
                  <div class="compartment-card-text">
                    <b>{{ element.previousProduct3 }}</b>
                  </div>
                  <div class="compartment-card-text">
                    {{ element.idtF3 }}
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-template>
        </div>
      </div>
    </div>
    <em
      id="transport-info-arrow"
      class="details-container-btn collapsible-panel"
      [ngClass]="
        timeslotCollapsed
          ? 'fa fa-angle-down transport-info-closed'
          : 'fa fa-angle-up transport-info-open'
      "
      (click)="timeslotCollapsed = !timeslotCollapsed"
    >
    </em>
  </div>
</div>
